import React from 'react'
import styled from 'styled-components'

const FreeCodeCamp = () => {
  return (
   <Wrapper>
    <div className='container'>
        <div>
        <img src='https://w7.pngwing.com/pngs/235/872/png-transparent-react-computer-icons-redux-javascript-others-logo-symmetry-nodejs-thumbnail.png' width={'100%'}/>
        </div>
        <div className='detail'>
            <p className='text'>kkkkkkkkkkkkkkkkkkkkkkkkkkklllllllllllllllllllllllllllllllllllllllkkkkkkkkkkkkkkkkkkkkkkkkkkk</p>
            <h3>hj</h3>
            <h3>jj</h3>
        </div>
      
    </div>
   </Wrapper>
  )
}


const Wrapper  = styled.section`
width: 70%;
/* max-width: 70%; */
background-color: yellow;
.container{
    display: flex;
    padding: 2rem;
    /* width: 40%; */
}
.detail{
    /* margin-inline: 2rem; */
    background-color: aqua;

}
.text{
    /* width:22px ; */
    background-color: red;
    word-wrap: break-word
}

`

export default FreeCodeCamp